import React from "react"
import {
    message,
    SuiInput,
    SuiForm,
} from "@sudy/sui-react"
// import optionsStore from './stores/optionsStore';
import postStore from "../../stores/postStore"
import $ from "jquery"

const imgUrl = `http://mapp.suda.edu.cn/_control/validateimage?tt=${new Date().getMilliseconds()}`

class SetPwd extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            current: 0,

        }
    }

    checkPwd(){
        const repwd = this.rePwdNode.getValue();
        const pwd = this.PwdNode.getValue();
        if (repwd !== pwd) {
            message.warning('密码不一致')
            return false ;
        }
        return true;
    }

    // 获取参数
    getValue() {
        if (!this.setPwdForm.verify() || !this.checkPwd()) {
            // message.info("请检查输入项")
            return false
        } else {
            console.log(this.setPwdForm.getFieldsValue())
            return this.setPwdForm.getFieldsValue()
        }
    }

    queryData(cur) {
        $.ajax({
            url: this.steps[cur].url,
            type: "post",
            dataType: "json",
            data: this.getParams(),
            success: function (response) {},
            error: function (xhr) {},
            complete: function () {},
        })
    }

    render() {
        const { passRuleInfo, passLengthInfo } = this.props
        return (
            <div>
                <SuiForm
                    bind={postStore}
                    ref={(node) => {
                        this.setPwdForm = node
                    }}
                >
                    <div className="ids-tips">
                        <p>请按照密码规则输入密码，密码规则如下</p>
                        <p>
                            {passRuleInfo}, {passLengthInfo}
                        </p>
                    </div>
                    <div className="app-item">
                        {/* <p>
                            <span className="ids-star">*</span>设置密码：
                        </p> */}
                        <SuiInput
                            ref={(node) => (this.PwdNode = node)}
                            name="password"
                            type="password"
                            style={{ width: "100%" }}
                           
                            defaultValue={""}
                            placeholder="请输入登录密码"
                            required
                            tip="请输入登录密码"
                            // onInput={() => this.checkPwd()}
                        />
                    </div>

                    <div className="app-item">
                        {/* <p>
                            <span className="ids-star">*</span>确认密码：
                        </p> */}
                        <SuiInput
                            ref={(node) => (this.rePwdNode = node)}
                            name="rePassword"
                            type="password"
                            style={{ width: "100%" }}
                            required
                            placeholder="请输入确认密码"
                            tip="请输入确认密码"
                            defaultValue={""}
                        />
                    </div>
                </SuiForm>
            </div>
        )
    }
}
export default SetPwd
